// does not support arrays
const parse = (qs) => {
  try {
    return Array.from(new URLSearchParams(qs).entries()).reduce(
      (acc, [k, v]) => {
        return {
          ...acc,
          [k]: v
        }
      },
      {}
    )
  } catch (e) {
    return {}
  }
}

const stringify = (data, skipNulls = false) =>
  Object.entries(data)
    .reduce((qs, [k, v]) => {
      if (!skipNulls || v != null) qs.append(k, v)
      return qs
    }, new URLSearchParams())
    .toString()

export { parse, stringify }
